export default __webpack_public_path__ + "static/Karmen Radtke-3bff1e995c1082a5c292cd3914a54a01.webp";